<template>
  <div>
    <v-card class="mb-0 px-0 mt-2 pt-0 elevation-0">
      <v-card-title class="px-0 mx-0">
        <v-spacer></v-spacer>
        <v-flex sm6 md4 lg3>
          <v-text-field
            append-icon="search"
            clearable
            label="Search "
            single-line
            hide-details
            v-if="this.$store.state.showSearch"
            v-model="search"
          ></v-text-field>
        </v-flex>

        <span xs1 class="text-xs-right mr-0 mt-2 py-0">
          <!-- <a class="font-weight-regular display-1 black--text" @click="addNew()">+</a> -->
          <!-- <div class="text-xs-right"> -->
          <v-menu
            offset-y
            :close-on-content-click="false"
            class="text-xs-right mx-4 my-0 py-0 align-center"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                small
                icon
                color="black"
                dark
                v-on="on"
                class="text-xs-right mx-0 mt-2 my-0 py-0"
              >
                <v-icon small>sort</v-icon>
              </v-btn>
            </template>
            <v-list value="first_name">
              <v-list-tile
                v-for="(item, index) in sortingItemsArtworks"
                :key="index.column"
                @click="changeSort(item.column)"
              >
                <v-list-tile-avatar v-if="item.column == sorting">
                  <v-icon>mdi-sort-ascending</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-avatar v-else>
                  <v-icon></v-icon>
                </v-list-tile-avatar>
                <v-list-tile-title>{{ item.name }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <!-- </div> -->
        </span>
      </v-card-title>

      <v-divider class="ml-2 mr-2"></v-divider>

      <!-- :headers="headers" -->

      <h3
        v-if="use_current_selection && artworks.length == 0"
        class="pa-5 ma-2 grey ligthen-3"
      >
        You have selected "Use artworks in current selection" but there are no
        artworks currently selected.
      </h3>
      <v-data-table
        v-if="artworks.length > 0"
        hide-headers
        :search="search"
        :items="filtered"
        item-key="id"
        item-value="id"
        v-model="selected"
        :custom-filter="customFilter"
        width="100%"
        class="elevation-0"
        disable-initial-sort
        light
        rows-per-page-text="Artworks per page"
        no-data-text="No Artworks match the filter criteria."
        :pagination.sync="p"
      >
        <template slot="items" slot-scope="props">
          <tr class="pb-0 mb-0">
            <!-- <td style="width:40px;">
              <v-layout  row wrap>
                <v-flex xs6>
                  <v-checkbox hide-details class="mt-1 pt-0" color="black"
                    v-model="props.selected"
                    @change="save_currently_selected(props.selected,props.item)"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs6>
                  <v-btn flat class="my-0 py-0" icon @click="removeArtwork(props.item)"><v-icon>close</v-icon></v-btn>
                </v-flex>
              </v-layout>
            </td> -->

            <td
              style="
                width: 20px !important;
                margin: 0px !important;
                padding: 0px !important;
              "
            >
              <v-flex align-start justify-start fill-height>
                <!-- <v-checkbox
                  class="pt-3 px-1 mx-0"
                  color="black"
                  hide-details
                  v-model="props.selected"
                ></v-checkbox> -->
                <!-- @change="save_currently_selected(props.selected,props.item)" -->
                <v-btn
                  flat
                  class="my-3 py-0 mx-0 px-0"
                  icon
                  @click="removeArtwork(props.item)"
                  ><v-icon>close</v-icon></v-btn
                >
              </v-flex>
            </td>
            <td
              style="
                text-align: center;
                vertical-align: text-top;
                width: 140px;
                padding: 7px 0 0 0;
              "
            >
              <img
                @error="imageUrlAlt"
                v-if="props.item.top_photo && props.item.top_photo_id > 0"
                v-bind:src="`${$globals.fileserver}/data/artwork/${props.item.id}/${props.item.top_photo_id}_th_big.jpg`"
                style="width: 120px; margin: 10px"
                :class="{
                  redBorder:
                    props.item.top_photo.width < 500 ||
                    props.item.top_photo.height < 500,
                }"
              />
              <img
                @error="imageUrlAlt"
                v-else-if="[12, 15, 16].includes(props.item.ownership)"
                v-bind:src="`${this.$globals.oldserver}/data/artwork/gemini/${props.item.accession_number}.jpg`"
                style="width: 120px; margin: 10px"
              />
              <!-- <img
                v-if="props.item.top_photo && props.item.top_photo_id > 0"
                v-bind:src="'http://tb-cms.org/data/artwork/' + props.item.id + '/' + props.item.top_photo_id + '_th_big.jpg'"
                style="width: 120px; margin:10px;"
                :class="{ redBorder: props.item.top_photo.width < 500 || props.item.top_photo.height < 500 }"
              /> -->
            </td>

            <td
              colspan="7"
              class="my-0 py-0 body-1 align-start justify-start row fill-height"
              style="vertical-align: top; padding: 7px 0 0 0"
            >
              <table
                width="100%"
                style="padding-top: 25px"
                class="my-2 py-0 body-1 align-start justify-start row"
              >
                <tr>
                  <td
                    class="
                      body-1
                      align-start
                      justify-start
                      row
                      fill-height
                      pt-2
                      pb-0
                      mb-0
                      mx-0
                      px-1
                    "
                  >
                    <div class="title black--text text-xs-left mb-1">
                      {{
                        props.item.artist
                          ? props.item.artist.name
                          : props.item.name
                      }}
                    </div>

                    <router-link
                      :to="{
                        name: 'EditArtwork',
                        params: { id: props.item.id, artwork: props.item },
                        path: `/artworks/edit/${props.item.id}`,
                      }"
                    >
                      <span
                        :class="[
                          { 'red--text': props.item.deaccessioned },
                          'subheading',
                        ]"
                      >
                        <b
                          >{{ props.item.title }},
                          {{ props.item.production_date_new }}</b
                        >
                      </span>
                    </router-link>

                    <v-spacer class="mb-2"></v-spacer>

                    <div v-if="props.item.dim_f_json">
                      <v-icon small color="black">square_foot</v-icon>
                      <span> {{ props.item.dim_f_json }}</span>
                    </div>
                    <div
                      v-if="
                        props.item.artwork_location_id &&
                        props.item.artwork_location_id != 465
                      "
                    >
                      <v-icon small color="black">edit_location</v-icon>
                      <span>
                        {{
                          get_location_name(props.item.artwork_location_id)
                        }}</span
                      >
                    </div>
                    <!-- {{get_location_name(props.item.artwork_location_id)}} -->
                    <!-- <div class="pt-3 ml-0 pl-0">
                      <v-chip
                        v-for="t in props.item.tags"
                        :key="t.id"
                        :color="t.color"
                        small
                      >{{t.name}}</v-chip>
                    </div> -->
                    <!-- <router-link :to="`/artist/view/${props.item.artist.id}`">{{ props.item.artist.full_name }}</router-link> -->
                  </td>
                </tr>
                <tr class="my-0 py-0">
                  <!-- <td> -->
                  <!-- <div class="mt-0"> -->
                  <!-- <router-link :to="{ name: 'EditArtwork', params: {id: props.item.id, artwork: props.item}, path: `/artworks/edit/${props.item.id}`}">
                        <v-icon small class="dense mr-2 black--text">edit</v-icon>
                  </router-link>-->
                  <!-- </div> -->
                  <!-- </td> -->
                  <td class="my-0 py-0 mx-0 px-1 text-xs-left">
                    <span>{{ props.item.accession_number }}</span>
                    <v-spacer></v-spacer>
                    <v-chip
                      v-if="props.item.visa_status == 3"
                      text-color="white"
                      color="red"
                      small
                      >F
                    </v-chip>
                    <!-- <span
                      style="color:red"
                      v-if="props.item.visa_status==3"
                    >F</span> -->
                    <span class="right">
                      <v-tooltip
                        left
                        v-if="
                          props.item.artwork_todos.filter((at) => at.done != 1)
                            .length > 0
                        "
                      >
                        <template #activator="data">
                          <v-chip dark small v-on="data.on">
                            <v-icon class="mr-3 small"
                              >mdi-format-list-numbered</v-icon
                            >
                            {{
                              props.item.artwork_todos.filter(
                                (at) => at.done != 1
                              ).length
                            }}
                          </v-chip>
                        </template>
                        <div>
                          <div
                            v-for="a in props.item.artwork_todos.filter(
                              (at) => at.done != 1
                            )"
                            :key="a.id"
                          >
                            – {{ a.title }}
                            <br />
                          </div>
                        </div>
                      </v-tooltip>
                    </span>
                  </td>
                  <!-- <td style="width:30px;">{{ props.item.classification }}</td> -->
                  <!-- <td style="width:10px;">
                    
                  </td>-->

                  <!-- <td style="width:10px;"> -->

                  <!-- <span style="color:green" v-if="props.item.open_todos_count>0">{{props.item.open_todos_count}}</span> -->
                  <!-- </td>                   -->
                </tr>
              </table>
            </td>
          </tr>
        </template>
      </v-data-table>

      <div v-if="this.selected.length > 0">
        <!-- <span v-if="save_selection_form_display==false">
          <v-btn flat outline color="primary" @click="add_to_selection_form=true">+ Add to Selection</v-btn>
        </span> -->
        <span v-if="save_selection_form_display == false">
          <v-btn flat outline color="red" @click="clear_selection()">
            Clear Selection</v-btn
          >
        </span>
        <span v-if="save_selection_form_display == false">
          <v-btn
            flat
            outline
            color="green"
            @click="save_selection_form_display = true"
            >Save Selection</v-btn
          >
        </span>
        <div v-else>
          <h3 class="ml-4">SAVE SELECTION</h3>
        </div>
      </div>

      <div v-if="save_selection_form_display">
        <v-layout row>
          <v-flex mx-4 my-3>
            <v-text-field
              v-model="selection_title"
              label="Selection Title"
              value=""
            ></v-text-field>
          </v-flex>
          <v-btn flat outline color="green" @click="saveCurrentSelectionToUser"
            >Save</v-btn
          >
          <v-btn
            flat
            outline
            color="red"
            @click="save_selection_form_display = false"
            >Cancel</v-btn
          >
        </v-layout>
      </div>
    </v-card>
  </div>
</template>

<script>
import _ from 'lodash'
import { serverBus } from '../../main'

export default {
  data() {
    return {
      p: { sortBy: 'sort_name', descending: false },
      sortingStore: '',
      add_to_selection_form: false,
      search: '',
      selection_title: '',
      save_selection_form_display: false,
      selected: [],
      // artworks: Object.assign([],this.$store.state.artworks),
      // all_artworks_for_filter:  Object.assign([], this.$store.state.artworks),
      // artworks_data: this.artworks,
      query_array: [],
      menu_acq_from: false,
      menu_acq_to: false,
      query_from: '',
      query_to: '',
      text_properties: [
        { name: 'Edition', value: 'edition_state' },
        { name: 'Title', value: 'title' },
        { name: 'Artist Name', value: 'artist' },
        {
          name: 'Media material description',
          value: 'media_material_description',
        },
      ],
      bool_properties: [
        { name: 'Certificate', value: 'certificate_new' },
        { name: 'Deaccessioned', value: 'deaccessioned' },
        { name: 'Signature', value: 'signature_new' },
        { name: 'To-Dos', value: 'todos' },
      ],
      tableData: [],
      sortingItemsArtworks: [
        { column: 'title', name: 'Title' },
        { column: 'sort_name', name: 'Artist' },
        // { column: 'last_name', name: 'Last Name' },
        { column: 'accession_number_for_sorting', name: 'Accession No.' },
        { column: 'acquisition_date', name: 'Acquisition Date' },
        { column: 'created_at', name: 'Date added to CMS' },
        { column: 'production_date_new', name: 'Production Date' },
        { column: 'type_of_work_id', name: 'Type of Work' },
        { column: 'visa_status', name: 'Freeport' },
        { column: 'artwork_todos.length', name: 'Todos' },
        { column: 'location_name', name: 'Location' },
        { column: 'id', name: 'ID' },
      ],
      headers: [
        // { sortable: false },
        { sortable: false },
        { text: 'Artist', value: 'name', align: 'center' },
        { text: '', value: 'full_name', align: 'center' },
        { text: '', value: 'sort_name', align: 'center' },
        { text: '', value: 'title', align: 'center' },
        { text: 'Accession No.', value: 'accession_number', align: 'center' },
        { text: 'Classification', value: 'classification', align: 'center' },
        { text: 'Freeport', value: 'visa_status', align: 'center' },
        {
          text: 'Todos',
          value: 'artwork_todos.filter(at => at.done != 1)',
          align: 'center',
        },
        // { text: 'Tags', value: 'tags', sortable: false }
      ],
      // headers: [
      //   { sortable: false, width: '20px'},
      //   { sortable: false, width: '20px'},
      //   {
      //     text: 'Artist',
      //     align: 'left',
      //     sortable: true,
      //     value: 'last_name'
      //   },
      //   { text: 'Acc. No.', value: 'accession_number', align: 'center' },
      //   { text: 'Class.', value: 'classification', align: 'center'},
      //   { text: 'Freeport', value: 'visa_status', align: 'center' }

      // ],
      filteredProperty: 'title',
      query: '',
      anquery1: '',
      anquery2: '',
      anquery3: '',
      anquery4: '',
      query1: '',
      activeFilters: [],
      data: [],
      // inverse: false
    }
  },
  props: ['use_current_selection', 'artworks'],
  computed: {
    sorting() {
      return this.sortingStore
    },
    // docasne vynute
    // exhibitions () {
    //   var o = Object.assign([], this.$store.state.exhibitions)
    //   o = o.map((a) => {a.select_text = `${a.duration_start_year ? a.duration_start_year + ' - ' : ''} ${a.title.replace(/<\/?[^>]+(>|$)/g, " ")}`; return a})
    //   o = o.sort(function(a, b){ if (a.select_text < b.select_text) { return -1; } if (a.select_text > b.select_text) { return 1; } return 0})
    //   return o
    // },
    ans() {
      var o = Object.assign([], this.$store.state.artworks)
      o = o.map((a) => (a = a.accession_number))
      // console.log (o)
      o = o.sort(function (a, b) {
        if (a < b) {
          return -1
        }
        if (a > b) {
          return 1
        }
        return 0
      })
      return o
    },
    artists() {
      return this.$store.state.artists
    },
    // artworks () { return this.$store.state.artworks },
    all_properties() {
      var all = this.text_properties.concat(this.bool_properties).concat([
        { name: 'Production Date', value: 'production_date_new' },
        { name: 'Deaccession Date', value: 'deaccession_date' },
        { name: 'Acquisition Date', value: 'acquisition_date' },
        { name: 'Classification', value: 'classification' },
        { name: 'Classification New', value: 'classification_new_id' },
        { name: 'Customs', value: 'visa_status' },
        { name: 'Location', value: 'artwork_location_id' },
        { name: 'Todos', value: 'todos' },
        { name: 'Acquisition Method', value: 'acquisition_method' },
        // {name: 'Exhibitions', value: 'exhibitions'},
        { name: 'Ownership', value: 'ownership' },
        { name: 'Aquired', value: 'acquired' },
        { name: 'Accession No.', value: 'accession_number' },
      ])
      all.sort(function (a, b) {
        var nameA = a.name.toUpperCase()
        var nameB = b.name.toUpperCase()
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }
        return 0
      })
      return all
    },
    select_tags() {
      return this.$store.state.tags
    },
    /// returns passed artworks minus deaccessioned and filtered by active filters
    filtered() {
      // if (this.use_current_selection == true) {
      //   if (this.$store.state.currentSelection.length > 0) {
      //     var filtered = Object.assign([], this.$store.state.currentSelection)
      //   } else {
      //     var filtered = this.artworks.filter(function(a) {
      //       return (a.ownership != 6 && a.ownership != 7 && a.ownership != 8 && a.ownership != 9 && a.ownership != 10)
      //     })
      //   }
      // } else {
      //   var filtered = this.artworks.filter(function(a) {
      //       return (a.ownership != 6 && a.ownership != 7 && a.ownership != 8 && a.ownership != 9 && a.ownership != 10)
      //   })
      //     // var filtered = Object.assign([], this.$store.state.artworks)
      // }
      // console.log('FILTERBOX - filtered - artworks before filtered = ' + this.artworks.length.toString())
      if (this.c_user.roles && this.c_user.roles.find((f) => f.shortcut == 'deac')) {
        var filtered = this.artworks
      } else {
        var filtered = this.artworks.filter((a) => a.deaccessioned != 1)
      }
      // deaccessioned=0 and (ownership is NULL or (ownership<>6 and ownership<>7 and ownership<>8 and ownership<>9 and ownership<>10))')

      // OVERIM CI DOSTAVAM ID ALEBO OBJEKT A NATIAHNEM OBJEKTY AK TREBA
      if (typeof filtered[0].id != 'number') {
        filtered = this.ids2o(this.$store.state.currentSelection)
      }

      var anquery1 = this.anquery1 ? this.anquery1 : 'xxxxxxxx'
      var anquery2 = this.anquery2 ? this.anquery2 : 'xxxxxxxx'
      var anquery3 = this.anquery3 ? this.anquery3 : 'xxxxxxxx'
      var anquery4 = this.anquery4 ? this.anquery4 : 'xxxxxxxx'

      this.activeFilters.forEach((filter) => {
        // console.log(filter)
        filtered = filtered.filter((record) => {
          var teststring = ''
          if (filter.name == 'artist') {
            teststring = 'record.name'
          } else {
            teststring = 'record[filter.name]'
          }
          var boolFilter = true
          if (
            this.text_properties.some((tp) => {
              return tp.value == filter.name
            })
          ) {
            boolFilter = this.text_properties.some((tp) => {
              return tp.value == filter.name
            })
              ? filter.inverse
                ? !new RegExp(filter.value, 'i').test(eval(teststring))
                : new RegExp(filter.value, 'i').test(eval(teststring))
              : filter.inverse
              ? record[filter.name] == filter.value
              : record[filter.name] != filter.value
          } else if (filter.name == 'classification') {
            boolFilter = filter.value_array.includes(record[filter.name])
          } else if (filter.name == 'visa_status') {
            boolFilter = filter.value_array.includes(record[filter.name])
          } else if (filter.name == 'ownership') {
            var boolFilter2 = filter.value_array.includes(record['ownership'])
            if (filter.value_array.includes('de')) {
              // console.log('de')
              var boolFilter1 = record['deaccessioned'] == 1
              boolFilter = boolFilter1 || boolFilter2
              // console.log(boolFilter1)
            } else {
              // console.log('de else')
              var boolFilter1 = record['deaccessioned'] != 1
              boolFilter = boolFilter1 && boolFilter2
            }
            // console.log(boolFilter2)
          } else if (filter.name == 'acquired') {
            boolFilter = filter.value_array.includes(record[filter.name])
          } else if (filter.name == 'acquisition_method') {
            boolFilter = filter.value_array.includes(record[filter.name])
          } else if (filter.name == 'artwork_location_id') {
            boolFilter = filter.value_array.includes(record[filter.name])
          } else if (filter.name == 'classification_new_id') {
            boolFilter = filter.value_array.includes(record[filter.name])
          } else if (filter.name == 'type_of_work_id') {
            boolFilter = filter.value_array.includes(record[filter.name])
          } else if (filter.name == 'accession_number') {
            boolFilter =
              // filter.anquery1 && filter.anquery1 == record['accession_number']
              (filter.anquery1
                ? new RegExp(filter.anquery1, 'i').test(
                    record['accession_number']
                  )
                : false) ||
              // filter.anquery2 && filter.anquery2 == record['accession_number']
              (filter.anquery2
                ? new RegExp(filter.anquery2, 'i').test(
                    record['accession_number']
                  )
                : false) ||
              // filter.anquery3 && filter.anquery3 == record['accession_number']
              (filter.anquery3
                ? new RegExp(filter.anquery3, 'i').test(
                    record['accession_number']
                  )
                : false) ||
              // filter.anquery4 && filter.anquery4 == record['accession_number']
              (filter.anquery4
                ? new RegExp(filter.anquery4, 'i').test(
                    record['accession_number']
                  )
                : false)
            console.log('boolFilter')
            // console.log(record['accession_number'])
            // console.log(this.anquery1)
            // console.log(this.anquery2)
            // console.log(this.anquery3)
            // console.log(this.anquery4)
            // console.log(boolFilter)
            // console.log(teststring)
            // console.log((new RegExp(this.query, 'i').test(record['accession_number'])))
            // console.log((new RegExp(this.query1, 'i').test(record['accession_number'])))
            // console.log((new RegExp(this.query2, 'i').test(record['accession_number'])))
            // console.log((new RegExp(this.query3, 'i').test(record['accession_number'])))
            // boolFilter = (filter.value_array.includes(record[filter.name]))
          } else if (filter.name == 'tags') {
            // POTREBUJEM ZISTIT CI ARTWORK (record.tags) MA NIEKTORU ZO ZVOLENYCH TAGOV (filter.value_array)
            // natiahnem si ID tagov pre tento artwork
            var at = record.tags.map((t) => t.id)
            boolFilter = at.some((t) => filter.value_array.includes(t))
            // var artwork_tags = Object.assign([], this.$store.state.tags.filter(t => {
            //   return t.artworks.map(a => a = a.artwork_id ).includes(record.id)
            // }))
            // artwork_tags = artwork_tags.map(a => a = a.id)
            // boolFilter = artwork_tags.filter(value => -1 !== filter.value_array.indexOf(value)).length > 0
          } else if (filter.name == 'exhibitions') {
            // console.log('filter')
            // potrebuje bool ci aktualna artwork (record) je v niektorej zo zvolenych exhibitions (filter.value_array)
            // 1. dam do noveho array vsetky artworks zo zvolenych exhibitions
            var eas = this.$store.state.exhibitions
              .filter((e) => filter.value_array.includes(e.id))
              .map((e) => (e = e.artworks.map((ea) => (ea = ea.id))))
              .flat()
            // console.log('eas')
            // console.log(eas)
            // console.log(record.id)
            // 2. zistim ci pole obsahuje aktualnu artwork (record)
            // console.log(this.$store.state.exhibitions.length)
            // natiahnem si exhibitions pre tuto artwork
            // var artworks_exhibitions = Object.assign([], this.$store.state.exhibitions.filter(e => {
            //   return e.artworks.includes(record.id)
            // }))
            // console.log(artworks_exhibitions)
            // artworks_exhibitions = artworks_exhibitions.map(a => a = a.id)
            // boolFilter = artworks_exhibitions.filter(value => -1 !== filter.value_array.indexOf(value)).length > 0
            boolFilter = eas.some((a) => a == record.id)
            // if (artworks_exhibitions.length > 0 ) {
            // console.log(artworks_exhibitions)
            // }
            // if (boolFilter){
            // console.log(filter.value_array)
            // }
            // console.log(boolFilter)

            // zistim ci je medzi nimi niektora z vybratych vo filtri
            // boolFilter = (filter.value_array.includes(record[filter.name]))
          } else if (filter.name == 'production_date_new') {
            var qf =
              filter.value_from == '' ? 1900 : parseInt(filter.value_from) - 1
            var qt =
              filter.value_to == '' ? 2100 : parseInt(filter.value_to) + 1
            boolFilter =
              record.production_date_new > qf && record.production_date_new < qt
            if (filter.inverse) {
              boolFilter = !boolFilter
            }
          } else if (filter.name == 'deaccession_date') {
            var qf = ''
            var qt = ''
            filter.value_from == ''
              ? (qf = '2100-01-01')
              : (qf = filter.value_from)
            filter.value_to == '' ? (qt = '2100-01-01') : (qt = filter.value_to)
            var r = new Date(record.deaccession_date)
            var f = new Date(qf)
            var t = new Date(qt)
            boolFilter = r > f && r < t
            if (filter.inverse) {
              boolFilter = !boolFilter
            }
          } else if (
            filter.name == 'acquisition_date' ||
            filter.name == 'import_date'
          ) {
            var qf = ''
            var qt = ''
            filter.value_from == ''
              ? (qf = '2100-01-01')
              : (qf = filter.value_from)
            filter.value_to == '' ? (qt = '2100-01-01') : (qt = filter.value_to)
            var r = new Date(record[filter.name])
            // r = r.setDate(r.getDate() + 1)
            // console.log(r)
            var f = new Date(qf)
            f = f.setDate(f.getDate() - 1)
            var t = new Date(qt)
            t = t.setDate(t.getDate() + 1)
            boolFilter = r > f && r < t
            if (filter.inverse) {
              boolFilter = !boolFilter
            }
          } else if (filter.name == 'location_history') {
            var qf = ''
            var qt = ''
            // filter.value_from == '' ? qf = '2100-01-01' :
            qf = filter.value_from
            // filter.value_to == '' ? qt = '2100-01-01' :
            qt = filter.value_to
            // var r = new Date(record.acquisition_date)
            // var f = new Date(qf)
            // var t = new Date(qt)
            boolFilter = this.$store.state.artwork_location_logs.find((a) => {
              return (
                a.artwork_id == record.id &&
                a.storage_in > qf &&
                a.storage_out < qt
              )
            })
            if (filter.inverse) {
              boolFilter = !boolFilter
            }
          } else if (
            this.bool_properties.some((tp) => {
              return tp.value == filter.name
            })
          ) {
            if (filter.name == 'todos') {
              boolFilter = this.$store.state.todos.find((a) => {
                return a.artwork_id == record.id
              })
              if (filter.value) {
                return boolFilter
              } else {
                return !boolFilter
              }
            } else {
              var db2bool = false
              if (
                record[filter.name] == '0' ||
                record[filter.name] == undefined ||
                record[filter.name] == null
              ) {
                db2bool = false
              } else {
                db2bool = true
              }
              var bool2string = filter.value ? '0' : '1'
              boolFilter = db2bool == filter.value
            }
            if (filter.inverse) {
              boolFilter = !boolFilter
            }
          }
          return boolFilter
        })
      })
      var arr = this.o2ids(filtered, 'id')
      // this.$store.dispatch('saveCurrentSelection',filtered)
      // var test= filtered.map(a => a=a.id)
      // console.log(arr)
      // console.log(arr)
      // console.log('FILTERBOX - filtered - artworks AFTER filtered = ' + filtered.length.toString())

      this.$store.dispatch('postFilterResults', arr)
      this.updateFilteredF(filtered)
      return filtered
    },
  },
  methods: {
    imageUrlAlt(event) {
      event.target.src = '/static/no_image.jpg'
    },
    changeSort(a) {
      this.sortingStore = a
      this.$store.dispatch('setSorting', {
        sorting: { section: 'lists', column: a },
      })
      this.p.sortBy = a
      this.p.descending = !this.p.descending
    },
    customFilter(items, search, filter) {
      search = search.toString().toLowerCase()
      return items.filter((row) => filter(row['title'] + row['name'], search))
    },
    // get_location_name (id) {
    //   var l = this.$store.state.locations.find(l => l.id === id)
    //   return l ? l.name : ''
    // },
    saveCurrentSelectionToUser() {
      // console.log(this.selection_title)
      this.$store.dispatch('saveCurrentSelectionToUser', {
        artworks: this.$store.state.currentSelection,
        title: this.selection_title,
        created_at: new Date().toISOString().substring(0, 19).replace('T', ' '),
      })
      this.save_selection_form_display = false
      this.selection_title = ''
    },
    clear_selection() {
      this.$store.dispatch('clearCurrentSelection')
      this.selected = []
    },
    // addToSelection (e) {
    //   this.$store.dispatch('addToCurrentSelection',e)
    // },
    save_currently_selected(isSelected, b) {
      // console.log('--- save_currently_selected')
      // console.log('isSelected = ' + isSelected)
      // console.log('b = ' + b.id)
      setTimeout(
        function () {
          var tempSelection = Object.assign(
            [],
            this.$store.state.currentSelection
          )
          // console.log(tempSelection)
          if (!isSelected) {
            // console.log('isSelected true')
            if (!tempSelection.includes(b.id)) {
              // console.log('doesnt include')
              tempSelection.push(b.id)
            }
          } else {
            // console.log('isSelected false')
            var index = tempSelection.indexOf(b.id)
            // console.log('index = ' + index)
            tempSelection.splice(index, 1)
          }
          // this.$store.state.currentSelection
          // console.log(tempSelection)
          // this.selected.forEach(s => {
          //   if (!tempSelection.includes(s)) {
          //     tempSelection.push(s)
          //   }
          // })
          // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
          this.$store.dispatch('saveCurrentSelection', tempSelection)
        }.bind(this),
        1000
      )
    },
    o2ids(array, prop) {
      return array.map((a) => a[prop])
    },
    ids2o(array) {
      var objs = Object.assign([], this.$store.state.artworks)
      var out = objs.filter((a) => {
        // console.log(array.includes(a.id))
        return array.includes(a.id)
      })
      return out
    },
    // function related: target_array, target_id_value, target_id_key
    related(target_id_value, target_id_key) {
      var out = this.artworks.filter((a) => a[target_id_key] == target_id_value)
      return out
    },
    keys2sentence(ks, fn) {
      // console.log(ks)
      // console.log(fn)
      var out = []
      for (var k in ks) {
        if (fn == 'acquisition_method') {
          for (var s in this.constants.ACQUISITION_METHODS) {
            if (ks[k] == this.constants.ACQUISITION_METHODS[s].id) {
              out.push(this.constants.ACQUISITION_METHODS[s].name)
            }
          }
          // return out.join(', ')
        } else if (fn == 'visa_status') {
          for (var s in this.constants.VISA_STATUSES) {
            if (ks[k] == this.constants.VISA_STATUSES[s].id) {
              out.push(this.constants.VISA_STATUSES[s].name)
            }
          }
          // return out.join(', ')
        } else if (fn == 'artwork_location_id') {
          for (var s in this.$store.state.locations) {
            // console.log('ks[k]')
            // console.log(ks[k])
            // console.log('this.$store.state.locations[s].id')
            // console.log(this.$store.state.locations[s].id)
            if (ks[k] == this.$store.state.locations[s].id) {
              out.push(this.$store.state.locations[s].name)
            }
          }
          // console.log(out)
          // return out.join(', ')
        } else if (fn == 'accession_number') {
          out.push(ks[k])
          // return out.join(', ')
        }
      }
      return out
    },
    save(date) {
      this.$refs.menu_acq_from.save(date)
    },
    removeArtwork(e) {
      if (this.use_current_selection == true) {
        if (this.$store.state.currentSelection.length == 1) {
          serverBus.$emit('setUseCurrentSelectionCheckboxToFalse', false)
        }
        this.$store.dispatch('removeFromCurrentSelection', e.id)
      } else {
        var i = this.artworks.indexOf(e)
        this.artworks.splice(i, 1)
      }
    },
    loadCurrentSelection() {
      this.tableData = this.$store.state.currentSelection
    },
    addFilter() {
      this.activeFilters.push({
        name: this.filteredProperty,
        value: this.query,
        value_from: this.query_from,
        value_to: this.query_to,
        value_array: this.query_array,
      })
      this.query = ''
      this.query_from = ''
      this.query_to = ''
      this.query_array = []
      this.filteredProperty = 'title'
    },
    updateFilteredF(s) {
      // console.log(s)
      serverBus.$emit('updateFiltered', s)
    },
    inverse(idx) {
      this.activeFilters.push({
        name: this.activeFilters[idx].name,
        value: this.activeFilters[idx].value,
        value_from: this.activeFilters[idx].value_from,
        value_to: this.activeFilters[idx].value_to,
        value_array: this.activeFilters[idx].value_array,
        inverse: this.activeFilters[idx].inverse ? false : true,
      })
      this.activeFilters.splice(idx, 1)
      // this.query = ''
    },
    removeFilter(idx) {
      this.activeFilters.splice(idx, 1)
    },
  },
  watch: {
    menu_acq_from(val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menu_acq_to(val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
  },
  created() {
    // console.log(this.artworks.length)
    this.sortingStore = this.$store.state.sorting.lists
    serverBus.$on('updateFilters', (activeFilters) => {
      this.activeFilters = activeFilters
    })
  },
}
</script>

<style scoped>
.redBorder {
  border: solid red 3px;
}
/* td {height: 120px !important;} */
a {
  text-decoration: none;
  color: #222;
}
a:hover {
  text-decoration: underline;
  color: #000;
}
/*.hoverDetect:hover img {
    -webkit-transform: scale(3);
    -moz-transform: scale(3);
    -ms-transform: scale(3);
    transform: scale(3); */
/* -webkit-transition: -webkit-transform .1s ease-out;
    -webkit-transition: transform .1s ease-out;
    -moz-transition: transform .1s ease-out;
    transition: transform .1s ease-out; */
/* } */
.carda {
  /* background: #F5F5F5; */
  padding: 5px;
  display: inline-block;
  margin: 0 0 0.2em;
  width: 100%;
  /* cursor: pointer; */
  transition: all 100ms ease-in-out;
}
/* .carda:hover { */
/* transform: translateY(-0.5em); */
/* background: #EBEBEB; */
/* } */
img {
  display: block;
  width: 100%;
}
/* .v-input--selection-controls.v-input .v-label {
    color: rgba(255, 255, 255, 0.8) !important;
} */
/* .datatable td {height: 120px !important;} */
</style>



// WEBPACK FOOTER //
// src/components/lists/FilterBox.vue